/* ==========================================================================
   SWIT 2.0 - camada de movimento e conexao
   Vanilla, sem dependencia. Carregado com defer no theme.liquid.
   Roda em TODA pagina: nada aqui pode quebrar se o elemento nao existir.
   ========================================================================== */
(function () {
  'use strict';

  if (window.swit2) return; // trava: se o asset carregar 2x, nao empilha patch de rede

  var doc = document;
  var root = doc.documentElement;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqMobile = window.matchMedia('(max-width: 999px)');
  var reduced = function () { return mqReduce.matches; };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- 1. scroll reveal ---------------------------------------- */
  var revealIO = null;

  function revealAll(ctx) {
    var els = $$('.s2-reveal:not(.is-in)', ctx);
    if (!els.length) return;
    // reduced motion: mostra tudo na hora e nao observa nada
    if (reduced() || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target); // nunca reobserva o que ja revelou
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) {
      var d = el.getAttribute('data-s2-delay');
      if (d) el.style.setProperty('--s2-delay', d);
      revealIO.observe(el);
    });
  }

  /* ---------- 2. --s2-scroll (0..1) para parallax do hero/aurora ------- */
  var ticking = false;
  var lastY = window.pageYOffset || 0;
  var lastProgress = -1;

  function onScrollFrame() {
    ticking = false;
    var y = window.pageYOffset || 0;
    if (!reduced()) {
      var max = Math.max(1, doc.body.scrollHeight - window.innerHeight);
      var p = Math.min(1, Math.max(0, y / max));
      // so escreve no :root quando muda de verdade (evita recalc de estilo por frame)
      if (Math.abs(p - lastProgress) > 0.0015) {
        lastProgress = p;
        root.style.setProperty('--s2-scroll', p.toFixed(4));
      }
    }
    updateHeader(y, lastY);
    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(onScrollFrame);
  }

  /* ---------- 4. header inteligente ----------------------------------- */
  // compacta ao rolar; no mobile some descendo e volta subindo.
  var headers = null;              // cache: nada de querySelectorAll por frame
  var isScrolled = null, isHidden = null;
  function getHeaders() { if (!headers) headers = $$('[data-s2-header]'); return headers; }

  function updateHeader(y, prevY) {
    var scrolled = y > 24;
    var hidden = isHidden === true;
    if (mqMobile.matches && y > 140 && y > prevY + 4) hidden = true;
    else if (y < prevY - 4 || y <= 140 || !mqMobile.matches) hidden = false;
    if (scrolled === isScrolled && hidden === isHidden) return; // nada mudou: nao toca no DOM
    isScrolled = scrolled; isHidden = hidden;
    root.classList.toggle('s2-scrolled', scrolled);
    root.classList.toggle('s2-nav-hidden', hidden);
    getHeaders().forEach(function (h) {
      h.classList.toggle('is-scrolled', scrolled);
      h.classList.toggle('is-hidden', hidden);
    });
  }

  // se o teclado levar o foco pra dentro do header escondido, ele volta
  doc.addEventListener('focusin', function (e) {
    if (isHidden !== true || !e.target || !e.target.closest) return;
    if (!e.target.closest('[data-s2-header]')) return;
    isHidden = false;
    root.classList.remove('s2-nav-hidden');
    getHeaders().forEach(function (h) { h.classList.remove('is-hidden'); });
  });

  /* ---------- 3. barra de combo global -------------------------------- */
  // 2 pecas -6% | 3 pecas -10% (desconto automatico do carrinho).
  // Percentual, nao valor fixo: o catalogo tem 3 precos (Premium adulto 89,90,
  // Confort adulto 104,90, infantil 79,90/89,90) e um valor fixo so seria verdade
  // em parte dos carrinhos. Trocado em 07/09/2026.
  var comboTimer = null, comboBusy = false;

  function comboBars() { return $$('[data-s2-combo]'); }

  function comboRender(count) {
    var bars = comboBars();
    if (!bars.length) return;
    bars.forEach(function (bar) {
      var d2 = esc(bar.getAttribute('data-s2-combo-off-2') || '6%');
      var d3 = esc(bar.getAttribute('data-s2-combo-off-3') || '10%');
      var html;
      if (count >= 3) html = 'Desconto de <b>' + d3 + '</b> aplicado no carrinho';
      else if (count === 2) html = 'Desconto de <b>' + d2 + '</b> aplicado! Adicione mais 1 e ganhe <b>' + d3 + '</b>';
      else if (count === 1) html = 'Adicione mais 1 e ganhe <b>' + d2 + '</b> de desconto';
      else html = 'Leve 2 e ganhe <b>' + d2 + '</b> · leve 3 e ganhe <b>' + d3 + '</b>';

      var msg = bar.querySelector('[data-s2-combo-msg]') || bar.querySelector('.s2-combo__msg');
      if (msg) {
        if (!msg.getAttribute('aria-live')) msg.setAttribute('aria-live', 'polite');
        if (msg.innerHTML !== html) msg.innerHTML = html;
      }

      var pct = Math.min(1, count / 3) * 100;
      var fill = bar.querySelector('[data-s2-combo-fill]') || bar.querySelector('.s2-combo__fill');
      if (fill) {
        fill.style.setProperty('--s2-progress', pct.toFixed(1) + '%');
        // a mensagem acima ja e lida por aria-live: a barra vira decoracao
        var track = fill.parentElement;
        if (track && !track.hasAttribute('role') && !track.hasAttribute('aria-hidden')) track.setAttribute('aria-hidden', 'true');
      }

      var steps = bar.querySelector('[data-s2-combo-steps]') || bar.querySelector('.s2-combo__steps');
      if (steps) {
        if (!steps.hasAttribute('aria-hidden')) steps.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(steps.children, function (step, i) {
          step.classList.toggle('is-done', count >= i + 1);
        });
      }
      bar.setAttribute('data-s2-combo-count', String(count));
    });
  }

  function comboFetch() {
    if (comboBusy || !comboBars().length) return;
    comboBusy = true;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) comboRender(cart.item_count || 0); })
      .catch(function () { /* silencio: nao pode logar erro em pagina sem carrinho */ })
      .then(function () { comboBusy = false; });
  }

  function comboSchedule() {
    if (!comboBars().length) return; // pagina sem barra: nem agenda timer
    clearTimeout(comboTimer);
    comboTimer = setTimeout(comboFetch, 150);
  }

  // a) evento nativo do Impact: disparado no <html> com bubbles -> chega no document
  doc.addEventListener('cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && typeof cart.item_count === 'number') comboRender(cart.item_count);
    else comboSchedule();
  });
  doc.addEventListener('cart:refresh', comboSchedule);

  // b) rede: rede de seguranca caso algum app mexa no carrinho sem emitir evento
  var CART_RX = /\/cart\/(add|change|update|clear)/;
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var p = _fetch.apply(this || window, arguments); // this||window: nao quebra fetch desestruturado
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_RX.test(url)) p.then(function (r) { if (r && r.ok) comboSchedule(); }, function () {});
      } catch (err) {}
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { try { this.__s2u = u || ''; } catch (e) {} return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      try { if (CART_RX.test(this.__s2u || '')) this.addEventListener('load', comboSchedule, { once: true }); } catch (e) {}
      return _send.apply(this, arguments);
    };
  }

  /* ---------- 5. contador animado [data-s2-count] --------------------- */
  // aceita 98.9, 98,9 e 1.477 (formato pt-BR) sem virar numero errado
  function toNumber(raw) {
    raw = String(raw == null ? '' : raw).trim();
    if (/^-?\d{1,3}(\.\d{3})+(,\d+)?$/.test(raw)) raw = raw.replace(/\./g, '').replace(',', '.');
    else raw = raw.replace(',', '.');
    return raw;
  }

  function countUp(el) {
    var raw = toNumber(el.getAttribute('data-s2-count'));
    var target = parseFloat(raw);
    if (isNaN(target)) return;
    var dec = Math.min(4, (raw.split('.')[1] || '').length);
    var pre = el.getAttribute('data-s2-count-prefix') || '';
    var suf = el.getAttribute('data-s2-count-suffix') || '';
    var fmt = function (n) {
      var s;
      try { s = n.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
      catch (e) { s = n.toFixed(dec); }
      return pre + s + suf;
    };
    if (reduced()) { el.textContent = fmt(target); return; }
    var dur = 1100, t0 = 0;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }

  var countIO = null;
  function countInit(ctx) {
    var els = $$('[data-s2-count]:not([data-s2-counted])', ctx);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.setAttribute('data-s2-counted', ''); countUp(el); }); return; }
    if (!countIO) {
      countIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          countIO.unobserve(e.target);
          e.target.setAttribute('data-s2-counted', '');
          countUp(e.target);
        });
      }, { threshold: 0.4 });
    }
    els.forEach(function (el) { countIO.observe(el); });
  }

  /* ---------- 6. tudo se conecta: variante -> espelhos de preco -------- */
  // Fonte 1 (nativa do Impact): 'variant:change' no form, detail.variant (price em centavos).
  // Fonte 2 (nossa): 'swit2:variant' com detail {variant, price, priceFormatted, title}.
  function brl(cents) {
    try { return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    catch (e) { return 'R$ ' + (cents / 100).toFixed(2).replace('.', ','); }
  }

  function mirrorVariant(d) {
    d = d || {};
    var v = d.variant || {};
    var cents = typeof d.price === 'number' ? d.price : v.price;
    var mirrors = $$('[data-s2-price-mirror]');
    if (!mirrors.length) return;
    mirrors.forEach(function (el) {
      var kind = el.getAttribute('data-s2-price-mirror') || 'price';
      var out = null;
      if (kind === 'pix' && typeof cents === 'number') out = brl(Math.round(cents * 0.97)); // Pix -3%
      else if (kind === 'title') out = d.title || v.title || '';
      else if (typeof cents === 'number') out = d.priceFormatted || brl(cents);
      if (out == null || out === '' || el.textContent === out) return;
      el.textContent = out;
      if (reduced()) return;
      el.classList.remove('is-pulse');
      requestAnimationFrame(function () { el.classList.add('is-pulse'); }); // reinicia a animacao sem forcar reflow
    });
  }

  doc.addEventListener('swit2:variant', function (e) { mirrorVariant(e && e.detail); });
  doc.addEventListener('variant:change', function (e) {
    var d = (e && e.detail) || {};
    if (!d.variant) return; // combinacao indisponivel: nao apaga o preco da tela
    mirrorVariant(d);
  });

  /* ---------- boot ---------------------------------------------------- */
  function init(ctx) {
    headers = null; // secao recarregada pode ter trocado o header
    revealAll(ctx);
    countInit(ctx);
    comboSchedule();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (mqReduce.addEventListener) mqReduce.addEventListener('change', function () { init(doc); });

  // editor de temas: secao recarregada precisa reobservar
  doc.addEventListener('shopify:section:load', function (e) { init(e.target || doc); });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); onScrollFrame(); });
  else { init(doc); onScrollFrame(); }

  // API minima para as secoes chamarem apos injetar HTML
  window.swit2 = {
    reveal: revealAll,
    refreshCombo: comboSchedule,
    init: init
  };
})();
